import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rename-dialog-content" }
const _hoisted_2 = { class: "rename-dialog-header" }
const _hoisted_3 = { class: "rename-dialog-body" }
const _hoisted_4 = { class: "rename-dialog-actions" }

import { type Conversation } from '@/services/conversationService';
import { useConversationStore } from '@/stores/conversationStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RenameConversationDialog',
  props: {
    modelValue: { type: Boolean },
    conversation: {}
  },
  emits: ["update:modelValue", "renamed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const conversationStore = useConversationStore();
const notificationStore = useNotificationStore();

const renameTitle = ref('');
const isRenaming = ref(false);

watch(
  () => props.conversation,
  (conversation) => {
    renameTitle.value = conversation?.title ?? '';
  },
);

const confirmRename = async () => {
  if (!props.conversation || !renameTitle.value.trim()) return;

  try {
    isRenaming.value = true;
    await conversationStore.renameConversationById(
      props.conversation.id,
      renameTitle.value.trim(),
    );
    emit('update:modelValue', false);
    emit('renamed');
  } catch (error) {
    console.error('Failed to rename conversation:', error);
    notificationStore.notify(
      'Failed to rename conversation. Please try again.',
    );
  } finally {
    isRenaming.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "723",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "rename-dialog-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "rename-dialog-title" }, "Rename Chat", -1)),
              _createVNode(_component_v_btn, {
                icon: "",
                size: "40",
                variant: "text",
                class: "rename-dialog-close",
                "aria-label": "Close dialog",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "40",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-close-circle-outline", -1)
                    ])),
                    _: 1,
                    __: [4]
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_text_field, {
                modelValue: renameTitle.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((renameTitle).value = $event)),
                flat: "",
                "hide-details": "",
                "bg-color": "#f9f9f9",
                label: "Conversation title",
                variant: "solo-filled",
                maxlength: "255",
                autofocus: "",
                onKeyup: _withKeys(confirmRename, ["enter"])
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  class: "rename-dialog-cancel-btn",
                  variant: "outlined",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" Cancel ", -1)
                  ])),
                  _: 1,
                  __: [6]
                }),
                _createVNode(_component_v_btn, {
                  class: "rename-dialog-confirm-btn",
                  loading: isRenaming.value,
                  disabled: !renameTitle.value.trim(),
                  onClick: confirmRename
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" Rename ", -1)
                  ])),
                  _: 1,
                  __: [7]
                }, 8, ["loading", "disabled"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})